import { useState } from 'react'

import {
	EuiButton,
	EuiPopover,
	EuiPopoverFooter,
} from '@equipmentshare/ds2'
import Parts from '../Parts'
import CopyButton from '../CopyButton'

import { TransactionItem } from 'graphql'
import buildPartsText from './helpers/build-parts-text'

export type ItemsColumnProps = {
	items: TransactionItem[],
}

export default function ItemsColumn( { items }: ItemsColumnProps ) {
	const [ isPopoverOpen, setIsPopoverOpen ] = useState( false )
	const onButtonClick = () => setIsPopoverOpen( !isPopoverOpen )
	const closePopover = () => setIsPopoverOpen( false )

	const totalParts = items.reduce( ( sum, item ) => sum + item.quantityOrdered, 0 )
	const buttonText = `${totalParts} item${totalParts > 1 ? 's' : ''}`
	const textToCopy = buildPartsText( items )

	const button = (
		<EuiButton
			color="text"
			onClick={onButtonClick}
		>
			{buttonText}
		</EuiButton>
	)

	return (
		<EuiPopover
			button={button}
			isOpen={isPopoverOpen}
			closePopover={closePopover}
		>
			<Parts items={items} />
			<EuiPopoverFooter>
				<CopyButton textToCopy={textToCopy} />
			</EuiPopoverFooter>
		</EuiPopover>
	)
}
